/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit SaveAction/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import React from 'react'
import TysiaButton from 'DesignSystem/TysiaButton/index'
import TysiaButtonText from 'DesignSystem/TysiaButton/TysiaButtonText/index'



/** @type {import('Simple/types.js').View} */
export default function SaveAction({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/Profile/Content/ContactInfo/Postal/NewAddress/Content/NewRelation/Add/Content/SaveAction",
  isSubmitting,
  onSubmit,
  disabled
  
}) {
let newRelationSubmitData = fromData.useDataSubmit({ viewPath,
context: 'new_relation',
})
let newRelationIsSubmittingData = fromData.useDataIsSubmitting({ viewPath,
context: 'new_relation',
})
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
  return (<React.Fragment
>
<TysiaButton
  viewPath={`${viewPath}/TysiaButton`}
 marginLeft={dtSpaceS}
 block={true}
 data="new_relation"
 disabled={newRelationIsSubmittingData}
 onClick={newRelationSubmitData}
 disabled={disabled}
>
{childProps => (
<TysiaButtonText
{...childProps}
  viewPath={`${viewPath}/TysiaButtonText`}
 text="Save"
/>
)}
</TysiaButton>
{children}
</React.Fragment>)
}